import { TaskKind } from "../../types/TrainingTypes";

export const TaskKinds: [TaskKind, string][] = [
    [TaskKind.PhrasePronunciationForms, 'Phrase, Pronunciation, Forms'],
    [TaskKind.PhrasePronunciation, 'Phrase, Pronunciation'],
    [TaskKind.PhraseForms, 'Phrase, Forms'],
    [TaskKind.Phrase, 'Phrase'],
    [TaskKind.PronunciationPhraseForms, 'Pronunciation, Phrase, Forms'],
    [TaskKind.PronunciationPhrase, 'Pronunciation, Phrase'],
    [TaskKind.PronunciationForms, 'Pronunciation, Forms'],
    [TaskKind.Pronunciation, 'Pronunciation'],
];
